import path from 'ramda/src/path'

export default sortFilters => path(['tab', 'fixedFilter'], sortFilters)
